import { Injectable } from '@angular/core';
import { DataService } from '../data.service';

@Injectable({
  providedIn: 'root'
})
export class BillingExportFileService {

  constructor( private dataService: DataService ) {}

  private readonly getBillingExportTypeFilterEndPoint: string =
    '/billingExportFile/getBillingExportFile/';

  async getBillingExportFile( billingInvoiceId: number,
      billingExportTypeId: number ): Promise<string> {

    const params = { billingInvoiceId, billingExportTypeId };

    return await this.dataService
                     .get<string>
                         (this.getBillingExportTypeFilterEndPoint, params)
                     .toPromise();
  }
}
